import React from "react"
import type { ReasoningUIPart } from "ai"
import Markdown from "react-markdown"
import { Box, componentStyles } from "@mallardbay/lib-react-components"

import { MESSAGE_PART_STATES } from "~components/shared/chat/chat-helpers"

interface Props {
    readonly part: ReasoningUIPart
}

export default function ChatMessageReasoning({ part }: Props) {
    const styles = useStyles()

    if (part.state !== MESSAGE_PART_STATES.DONE) return null

    return (
        <Box style={styles.root}>
            <Markdown>{part.text}</Markdown>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            opacity: 0.5,
        },
    })
}
